import { render, staticRenderFns } from "./ModalBottom.vue?vue&type=template&id=6073945b&scoped=true&"
import script from "./ModalBottom.vue?vue&type=script&lang=ts&"
export * from "./ModalBottom.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBottom.vue?vue&type=style&index=0&id=6073945b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073945b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/usr/www/nuxt/components/Icon/IconClose.vue').default})
